export const Y_AXIS_WIDTH = 50;
export const NUM_Y_AXIS_TICKS = 5;
